import { Link } from 'react-router-dom'
import { ArrowRight, Plug } from 'lucide-react'
import { JarvisCard } from './JarvisCard'
import { useConnections } from '@/lib/hooks'
import type { ConnectionProvider } from '@/types'

interface ConnectionPromptProps {
  required: ConnectionProvider
  label: string
  description: string
}

export function ConnectionPrompt({ required, label, description }: ConnectionPromptProps) {
  const { data, isLoading } = useConnections()
  if (isLoading) return null
  const connected = data?.items.find((c) => c.provider === required)?.status === 'connected'
  if (connected) return null

  return (
    <JarvisCard className="border-jarvis-amber/30 bg-jarvis-amber/5">
      <div className="flex items-center gap-4">
        <span className="w-10 h-10 rounded-lg bg-jarvis-amber/10 text-jarvis-amber flex items-center justify-center">
          <Plug size={18} />
        </span>
        <div className="flex-1">
          <div className="text-sm font-medium">Connect {label}</div>
          <div className="text-xs text-jarvis-muted mt-0.5">{description}</div>
        </div>
        <Link
          to="/setup"
          className="text-xs px-3 py-1.5 bg-jarvis-blue hover:bg-jarvis-blue-bright rounded-lg font-medium transition-colors flex items-center gap-1.5"
        >
          Connect <ArrowRight size={12} />
        </Link>
      </div>
    </JarvisCard>
  )
}
